export const pluralize = (word: string, count: number) => {
  if (count === 1) return word
  return `${word}s`
}

export const humanize = (str: string) => {
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str)) return str
  return str
    .replace(/^[\s_]+|[\s_]+$/g, "")
    .replace(/[_\s-]+/g, " ")
    .replace(/(?:^|\s)([a-z])/g, (m) => m.toUpperCase())
    .replace(/([a-z])([A-Z])/g, "$1 $2")
}

export function capitalize(word: string): string {
  const text = word.toLowerCase()
  return text.charAt(0).toUpperCase() + text.substring(1)
}

export function camelToHuman(name?: string | null): string {
  if (!name) return ""
  const words = name.match(/[A-Za-z][a-z]*/g) || []
  return words.map(capitalize).join(" ")
}

export const createFullName = (user?: null | undefined | { firstName?: string | null; lastName?: string | null }) => {
  if (!user) return ""
  return `${user.firstName} ${user.lastName}`
}

export const getPublishStatus = (date?: string | Date | null) => {
  if (!date) return "DRAFT"
  const now = new Date()
  const diff = now.getTime() - new Date(date).getTime()
  if (diff < 0) return "SCHEDULED"
  return "PUBLISHED"
}

export function toCamelCase(str: string): string {
  if (!str) return ""
  // Convert the entire string to lowercase
  let result = str.toLowerCase()
  // Replace underscores and hyphens with spaces
  result = result.replace(/[_-]/g, " ")
  // Split by spaces, filter out empty strings
  const words = result.split(" ").filter((word) => word.length > 0)
  // If no words remain, return empty string
  if (words.length === 0) return ""
  // First word stays as is, capitalize first letter of remaining words
  return (
    words[0] +
    words
      .slice(1)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("")
  )
}
